import { render, staticRenderFns } from "./WorkshiftLegend.vue?vue&type=template&id=432c5a72&scoped=true&"
import script from "./WorkshiftLegend.vue?vue&type=script&lang=js&"
export * from "./WorkshiftLegend.vue?vue&type=script&lang=js&"
import style0 from "./WorkshiftLegend.vue?vue&type=style&index=0&id=432c5a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c5a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432c5a72')) {
      api.createRecord('432c5a72', component.options)
    } else {
      api.reload('432c5a72', component.options)
    }
    module.hot.accept("./WorkshiftLegend.vue?vue&type=template&id=432c5a72&scoped=true&", function () {
      api.rerender('432c5a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/WorkshiftLegend.vue"
export default component.exports